import axios from 'axios';

const apiBase = typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : '';
const client = axios.create({
  baseURL: `${apiBase}api`,
});

client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    config.headers.authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

export default client;